/*
 * File: UIDateRadioGroup.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Radio group with one option being an element that allows entering a custom date range
 */
import React from "react";
import UIRadioListItem from "../UIRadioListItem";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core";
import UICustomDateRange from "./UICustomDateRange";
import PropTypes from "prop-types";

const styles = theme => ({
  textField: {
    textAlign: "left"
  },
  formLabel: {
    textAlign: "left",
    marginBottom: theme.spacing(-1)
  }
});

const UIDateRadioGroup = ({
  value,
  field,
  parentOnChange,
  startDate,
  endDate
}) => {
  const handleChange = event => {
    const fieldName = field.name;
    const selectedId = event.target.id;
    parentOnChange(fieldName, selectedId);
  };

  const customDateRangeFields = () => (
    <React.Fragment>
      <UIRadioListItem
        parentOnChange={handleChange}
        name={"Custom Date Range"}
        optionId={"1"}
        selectedId={value}
      />
      {value === "1" && (
        <UICustomDateRange
          dateOnChange={parentOnChange}
          fieldName={field.name}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </React.Fragment>
  );

  const standardizedDateRangeOptions = () => {
    return field.options.map(option => (
      <UIRadioListItem
        key={option.id}
        parentOnChange={handleChange}
        name={option.name}
        optionId={option.id}
        selectedId={value}
      />
    ));
  };

  return (
    <React.Fragment>
      {customDateRangeFields()}
      {standardizedDateRangeOptions()}
    </React.Fragment>
  );
};

UIDateRadioGroup.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  field: PropTypes.object.isRequired,
  parentOnChange: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string
};

export default withStyles(styles)(observer(UIDateRadioGroup));
